import React, {useState, useEffect, useRef} from 'react';
import CheckBox from '../../Shared/CheckBox/Checkbox';
import InputText from '../../Shared/TextInput/TextInput';
import PlaneLoader from './PlaneLoader';
import {connect} from 'react-redux';
import {isMobile} from 'react-device-detect';
import OtpInput from 'react-otp-input';
import {saleOTPSteps, customerTypeEnum} from '../CellcomAbroadLobbyBlock/cellcomAbroadVariables';
import {
  changePhoneInputHandler,
  onBlurHandler,
  setOtpVerifyCode,
  setSaleOtpChildrenStep,
  removeOtpDataChildren,
  hideOtpChildrenErrorMessage,
  saveToHistory,
  setChildrenOtpPhone,
} from '../CellcomAbroadLobbyBlock/cellcomAbroadBlockSlice';
import EpiContext from '@episerver/spa-core/Spa';
import {prepareUrl} from '../../../utilities/StringHelpers/StringHelpers';
import gaParams from '../../../utilities/analytics/constants';
import {gaEvent,gtag} from '../../../utilities/analytics/tracking';
import useExtendedEffect from '../../../utilities/hooks/useExtendedEffect';
import ReactSelect from '../../Shared/ReactSelect/ReactSelect';
import { setSelfcareSubscriber } from '../../Page/SelfCarePage/SelfCareSlice'
import {
  setRestrictedCodeError,
  setOtpError
} from 'app/utilities/authentication/authenticationSlice';

function BottomBlockChildren(props) {
  const ref = useRef();

  useEffect(() => {
    if (props.data.otpDataChildren.isOTPValidated) {
      //if (props.data.otpDataChildren.isOTPValidated || props.authentication?.loginData?.isFullAuthenticated) {
      props.setSaleOtpChildrenStep(saleOTPSteps.AFTER_INPUT);
    } else {
      if (!isMobile && props.data.saleOTPStep == saleOTPSteps.MOBILE_INPUT) {
        ref.current?.focus();
      }
    }
  }, []);

  useEffect(() => {
    if (props.data.otpDataChildren.saleOTPStep != saleOTPSteps.LOADER) {
      props.saveToHistory();
    }
  }, [props.data.otpDataChildren.saleOTPStep]);

  useEffect(() => {
    if ('OTPCredential' in window) {
      async function fetchOtp() {
        try {
          const otp = await navigator.credentials.get({
            otp: { transport: ['sms'] },
          });
          if (otp?.code) {
            handleChangeOTPCode(otp.code);
          }
        } catch (err) {
          console.error('Error fetching OTP:', err);
        }
      }
      fetchOtp();
    }
  }, []);

  function handleChangeOTPCode(otp) {
    props.setOtpError(null);
    props.setRestrictedCodeError(null)
    if (props.data.otpDataChildren.showWrongOtpCodeMessage) {
      props.hideOtpChildrenErrorMessage();
    }

    props.setOtpVerifyCode({verifyCode: otp});
  }

  const openAgreementPDF = () => {
    switch (props.businessOrPrivate) {
      case customerTypeEnum.PRIVATE:
        if (props.data.startedFromPackage) {
          gtag4({
            event: 'CellcomAbroad_Step11_InstallPackageButton',
            button: 'להתקנת החבילה',
            step: '11',
            action: 'InstallPackageButton',
            process_type: 'private',
            funnel_name: '3 - Package',
          });
        } else {
          gaEvent(
            gaParams.ABROAD_TICKET_OPEN_TERMS_LINK_PRIVATE.category,
            gaParams.ABROAD_TICKET_OPEN_TERMS_LINK_PRIVATE.eventType,
            gaParams.ABROAD_TICKET_OPEN_TERMS_LINK_PRIVATE.eventParams
          );
        }

        break;
      case customerTypeEnum.BUSINESS:
        if (props.data.startedFromPackage) {
          gaEvent(
            gaParams.ABROAD_TICKET_OPEN_TERMS_LINK_BUSINESS_FROM_PACKAGE.category,
            gaParams.ABROAD_TICKET_OPEN_TERMS_LINK_BUSINESS_FROM_PACKAGE.eventType,
            gaParams.ABROAD_TICKET_OPEN_TERMS_LINK_BUSINESS_FROM_PACKAGE.eventParams
          );
        } else {
          gaEvent(
            gaParams.ABROAD_TICKET_OPEN_TERMS_LINK_BUSINESS.category,
            gaParams.ABROAD_TICKET_OPEN_TERMS_LINK_BUSINESS.eventType,
            gaParams.ABROAD_TICKET_OPEN_TERMS_LINK_BUSINESS.eventParams
          );
        }
        break;
      default:
        break;
    }
    prepareUrl(props.data.selectedAbroadPackage?.policiesEpi, EpiContext);
  };

  const getPhoneNumberHtml = () => {
    if (
      (props.authentication?.loginData?.isFullAuthenticated && props.data.relatedPhoneNumbers?.length > 1) ||
      props.data.isJETAuthentication
    ) {
      return (
        <ReactSelect
          getOptionLabel={(option) => option}
          getOptionValue={(option) => option}
          placeholder={props.data.otpDataChildren.otpPhone || 'בחר מנוי'}
          value={props.data.relatedPhoneNumbers[0]}
          name='selected'
          options={props.data.relatedPhoneNumbers.filter((option) => option != props.selectedSubscriber)}
          onChange={(phone) => setAndValidatePhone(phone)}
        />
      );
    } else {
      return <span className='bold mx-1'>{props.data.otpDataChildren.otpPhone}</span>;
    }
  };

  const setAndValidatePhone = (phone) => {
    props.setChildrenOtpPhone(phone);
    props.submitValidateCustomerType(phone);
    props.setSelfcareSubscriber(phone);
  };


  function renderStep(step) {
    switch (step) {
      case saleOTPSteps.MOBILE_INPUT:
        return (
          <>
            <div className='bottom-where-flight-to-header'>מי טס?</div>
            {isMobile ? (
              <div className='package-family-id'>המנוי צריך להיות תחת אותם ת.ז. ואמצעי תשלום של החבילה הראשית</div>
            ) : (
              <div className='package-family-id'>
                המנוי צריך להיות תחת אותם ת.ז. ואמצעי תשלום של
                <br /> החבילה הראשית
              </div>
            )}
            <div className='phone-input-container'>
              <InputText
                className='otp-phone-input'
                ref={ref}
                name='phone'
                type='tel'
                pattern='[0-9]*'
                id='phone'
                maxLength='10'
                autoComplete='off'
                placeholder={props.placeholder ?? 'הנייד שעליו נתקין את החבילה'}
                required='required'
                value={props.data.otpPhoneForm.phone}
                error={props.data.otpPhoneForm.errors.phone}
                onChange={(e) => props.changePhoneInputHandler({target: e.target, form: props.data.otpPhoneForm})}
              />
            </div>
            {(props.authentication.formError.otpCodeError != null ||  props.data.otpCodeForm.valid == "") && (
              <div className='error-container text-center'>
                <span>{props.authentication.formError.otpCodeError || props.data.otpCodeForm.errors.verifyCode}</span>
              </div>
            )}
          </>
        );
      case saleOTPSteps.OTP:
        return (
          <>
            <div className='bottom-where-flight-to-header' style={{marginBottom: 'unset'}}>
              מי טס?
            </div>
            <div className='bottom-where-flight-to-text' style={{alignSelf: 'center', marginBottom: '7px', fontSize: '15px'}}>
              הקלידו את הקוד ששלחנו לנייד
            </div>
            <div className='otp-verify-code'>
              <OtpInput
                shouldAutoFocus={true}
                value={props.data.otpCodeForm.verifyCode}
                onChange={handleChangeOTPCode}
                numInputs={6}
                isInputNum={true}
                separator={<span className='inputSeparator'></span>}
                inputStyle={`input-design`}
                containerStyle={`mainDivInside`}
                renderInput={(inputProps, index) => (
                  <input {...inputProps} key={index} autoComplete="one-time-code" />
                )}
              />
            </div>
            {(props.authentication.formError.otpCodeError != null ||  props.data.otpCodeForm.valid == "") && (
              <div className='error-container text-center'>
                <span>{props.authentication.formError.otpCodeError || props.data.otpCodeForm.errors.verifyCode}</span>
              </div>
            )}
          </>
        );
      case saleOTPSteps.LOADER:
        return <PlaneLoader text={'רק רגע, בודקים את המספר'} />;
      case saleOTPSteps.SELECT_FAMILY_MEMBER:
        var showRelatedFamilyNumbers = props.authentication?.loginData?.isFullAuthenticated || props.authentication?.loginData?.isOtpExtendedAuthenticated ;
        return (
          <>
            <div className='bottom-where-flight-to-header'>מי טס?</div>
               <>
                  <div className='phone-input-container'>
                    <InputText
                      className='otp-phone-input'
                      ref={ref}
                      name='phone'
                      type='tel'
                      pattern='[0-9]*'
                      id='phone'
                      maxLength='10'
                      autoComplete='off'
                      placeholder={props.placeholder ?? 'הנייד שעליו נתקין את החבילה'}
                      required='required'
                      value={props.data.otpDataChildren.otpPhone}
                      onChange={(e) => props.setChildrenOtpPhone(e.target.value)}
                    />
                  </div>
                <CheckAgreementCheckbox props={props} />
               </>
          </>
        );
      case saleOTPSteps.AFTER_INPUT:
        return (
          <>
            <div className='bottom-where-flight-to-header'>מי טס?</div>

            <div
              className={`${
                props.authentication?.loginData?.isFullAuthenticated ? 'd-flex flex-wrap align-items-center' : ''
              } bottom-where-flight-to-text`}>
              {/* <span
                className={`${
                  props.authentication?.loginData?.isFullAuthenticated && props.data.relatedPhoneNumbers?.length > 1 ? 'pb-10' : ''
                }`}> */}
              <span>הנייד שעליו נתקין את החבילה</span>
              <span className='bold mx-1'>{props.data.otpDataChildren.otpPhone}</span>
              {/* {getPhoneNumberHtml()} */}
            </div>
            <CheckAgreementCheckbox props={props} />
            {props.showErrorMessage &&
              <div className='bottom-error-message newPurple'>אנחנו צריכים את האישור שלכם כדי להתקדם</div>}
            {props.NeedToSignCollaborationApproval && props.businessOrPrivate == 'Private' && (
              <div className='bottom-where-flight-to-text'>
                <div className='bottom-checkbox'>
                  <CheckBox
                    id='collaborateCheckbox'
                    onCheck={() => props.onCheckCollaboration()}
                    onUncheck={() => props.onUncheckCollaboration()}
                    checked={props.checkBoxCollaborationChecked}
                    label={props.checkBoxText}
                  />
                </div>
              </div>
            )}

          </>
        );
      default:
        return null;
    }
  }

  return <div className='bottom-where-flight-to-box'>{renderStep(props.data.otpDataChildren.saleOTPStep)}</div>;
}

const mapStateToProps = (state) => ({
  data: state.cellcomAbroad,
  authentication: state.authentication,
  selectedSubscriber:state.selfcarePage.selectedSubscriber.productSubscriberNo,
});

const mapDispatchToProps = {
  changePhoneInputHandler,
  onBlurHandler,
  setOtpVerifyCode,
  setSaleOtpChildrenStep,
  removeOtpDataChildren,
  hideOtpChildrenErrorMessage,
  saveToHistory,
  setChildrenOtpPhone,
  setSelfcareSubscriber,
  setRestrictedCodeError,
  setOtpError
};

export default connect(mapStateToProps, mapDispatchToProps)(BottomBlockChildren);


const CheckAgreementCheckbox = ({props}) => (
  <div className='bottom-where-flight-to-text'>
  <div className='bottom-checkbox'>
    <CheckBox
      id='agreementCheckbox'
      onCheck={() => props.onCheck()}
      onUncheck={() => props.onUncheck()}
      checked={props.checkBoxChecked}
      label={''}
    />
  </div>
  <div className='bottom-confirm-line'>
    אני מאשר את{' '}
    <span
      style={{fontWeight: 'bold', cursor: 'pointer'}}
      onClick={() => (props.data.selectedAbroadPackage?.policiesEpi ? openAgreementPDF() : null)}>
      תנאי החבילה{' '}
    </span>
  </div>
</div>
);